import getFocusedInboxRollupStore from '../store/store';
import InboxViewType from 'owa-service/lib/contract/InboxViewType';

const isValidRollupStore = () => {
    const { uniqueSenders, unseenCountToDisplay, viewType } = getFocusedInboxRollupStore();
    return (
        !!uniqueSenders &&
        !!unseenCountToDisplay &&
        (viewType === InboxViewType.FocusedView || viewType === InboxViewType.ClutterView)
    );
};

export default isValidRollupStore;
